import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "dialog-footer" }

import { ref } from "vue";
import type { FormInstance } from "element-plus";
import ReportService from "@/projects/tenant/modules/report/services/ReportService";
import notification from "@/core/plugins/notification";


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateReport',
  emits: ["fetchData"],
  setup(__props, { expose: __expose, emit: emits }) {

const isLoading = ref(false);
const dialogRef = ref(false);
const ruleFormRef = ref<FormInstance>();
const query = ref<any>({});
const formData = ref<any>({});
const queryDate = ref<any>(["from", "to", "date", "month"]);
const groups = ref<any>([]);

const showSelectByGroup = ref(false);
const selectByGroup = ref(true);

const productTypes = ref<any>([
  { label: "FX STD", value: 17 },
  { label: "FX Alpha", value: 20 },
  { label: "IND STD", value: 16 },
  { label: "IND Alpha", value: 19 },
  { label: "CFD STD", value: 15 },
  { label: "CFD Alpha", value: 18 },
]);

const rules = {
  accountNumber: [
    { required: true, message: "Please input account number", trigger: "blur" },
  ],
  uid: [{ required: true, message: "Please input uid", trigger: "blur" }],
  group: [
    { required: true, message: "Please select a group", trigger: "blur" },
  ],
  date: [{ required: true, message: "Please select a date", trigger: "blur" }],
  from: [
    { required: true, message: "Please select a from date", trigger: "blur" },
  ],
  to: [{ required: true, message: "Please select a to date", trigger: "blur" }],
  type: [{ required: true, message: "Please select a type", trigger: "blur" }],
};

const show = async (data: any, _group) => {
  dialogRef.value = true;
  formData.value = data;
  groups.value = _group;
  if (formData.value.query && typeof formData.value.query === "string") {
    query.value = JSON.parse(formData.value.query);
  } else {
    query.value = formData.value.query || {};
  }
  if (query.value.type === null) {
    query.value.type = productTypes.value[0].value;
  }
  if (formData.value.key.includes("ClientStatement")) {
    showSelectByGroup.value = true;
    changeSelection();
  }
};
const close = () => {
  formData.value = {};
  query.value = {};
  dialogRef.value = false;
  showSelectByGroup.value = false;
  selectByGroup.value = true;
};

const changeSelection = () => {
  console.log("selectByGroup", selectByGroup.value);
  if (selectByGroup.value == true) {
    delete query.value.accountNumbers;
    query.value.group = null;
  } else {
    delete query.value.group;
    query.value.accountNumbers = null;
  }
};

const submit = async () => {
  if (!ruleFormRef.value) return;
  let isValid = false;
  await ruleFormRef.value.validate(async (valid, fields) => {
    isValid = valid;
  });
  if (!isValid) return;
  formData.value.query = query.value;
  isLoading.value = true;
  try {
    formData.value.query = query.value;
    await ReportService.postReportRequest(formData.value);
    emits("fetchData");
    close();
  } catch (error) {
    console.error(error);
    notification.danger();
  }
  isLoading.value = false;
};



__expose({
  show,
});

return (_ctx: any,_cache: any) => {
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: dialogRef.value,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((dialogRef).value = $event)),
    title: "Create Report Types",
    width: "500",
    "align-center": "",
    "before-close": close
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_button, {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (dialogRef.value = false)),
          disabled: isLoading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.cancel")), 1)
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          type: "primary",
          loading: isLoading.value,
          onClick: submit
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.submit")), 1)
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        ref_key: "ruleFormRef",
        ref: ruleFormRef,
        model: query.value,
        rules: rules,
        "label-position": "top"
      }, {
        default: _withCtx(() => [
          (showSelectByGroup.value)
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 0,
                label: "Group or Account Numbers"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio_group, {
                    modelValue: selectByGroup.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectByGroup).value = $event)),
                    disabled: isLoading.value,
                    onChange: _cache[1] || (_cache[1] = ($event: any) => (changeSelection()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio, { label: true }, {
                        default: _withCtx(() => [
                          _createTextVNode("Group")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_radio, { label: false }, {
                        default: _withCtx(() => [
                          _createTextVNode("AccountNumbers")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(query.value, (item, index) => {
            return (_openBlock(), _createBlock(_component_el_form_item, {
              key: index,
              label: index,
              prop: index
            }, {
              default: _withCtx(() => [
                (queryDate.value.includes(index))
                  ? (_openBlock(), _createBlock(_component_el_date_picker, {
                      key: 0,
                      modelValue: query.value[index],
                      "onUpdate:modelValue": ($event: any) => ((query.value[index]) = $event),
                      type: index === 'month' ? 'month' : 'date',
                      format: index === 'month' ? 'YYYY-MM' : 'YYYY-MM-DD',
                      "value-format": index === 'month' ? 'YYYY-MM' : 'YYYY-MM-DD',
                      disabled: isLoading.value
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "type", "format", "value-format", "disabled"]))
                  : (index === 'group' && groups.value.length !== 0)
                    ? (_openBlock(), _createBlock(_component_el_select, {
                        key: 1,
                        modelValue: query.value[index],
                        "onUpdate:modelValue": ($event: any) => ((query.value[index]) = $event),
                        filterable: "",
                        disabled: isLoading.value
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groups.value, (group) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: group,
                              value: group
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(group), 1)
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1032, ["modelValue", "onUpdate:modelValue", "disabled"]))
                    : (index === 'type')
                      ? (_openBlock(), _createBlock(_component_el_select, {
                          key: 2,
                          modelValue: query.value[index],
                          "onUpdate:modelValue": ($event: any) => ((query.value[index]) = $event),
                          disabled: isLoading.value
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productTypes.value, (type) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: type.value,
                                value: type.value,
                                label: type.label
                              }, null, 8, ["value", "label"]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1032, ["modelValue", "onUpdate:modelValue", "disabled"]))
                      : (_openBlock(), _createBlock(_component_el_input, {
                          key: 3,
                          modelValue: query.value[index],
                          "onUpdate:modelValue": ($event: any) => ((query.value[index]) = $event),
                          onInput: ($event: any) => (query.value[index] = query.value[index].toUpperCase()),
                          disabled: isLoading.value
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput", "disabled"]))
              ]),
              _: 2
            }, 1032, ["label", "prop"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})